import client from '../../utils/react-query/client';

export const USER_HINT_MESSAGES = {
  ACCEPT_REQUEST_FLOW:
    'Scheduling now happens here. Accept a request to send a booking link, pick the date & time yourself, or set up a consultation.',
} as const;

export type UserHintKey = keyof typeof USER_HINT_MESSAGES;

const STORAGE_KEY = 'porter-dismissed-hints';

export function getDismissedHints(): string[] {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
}

export function dismissUserHint(hintKey: UserHintKey) {
  const dismissed = [...new Set([...getDismissedHints(), hintKey])];
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(dismissed));
  } catch {
    // Storage unavailable — the hint just shows again next session
  }
  // The cache is the client-side state — every mounted consumer hides immediately
  client.setQueriesData<string[]>({ queryKey: ['user-hints'] }, dismissed);
}
